export default {
  modalImage: {
    open: false,
    dir: 'avisos',
    resolve: null,
    reject: null
  },
  toast: {
    message: null,
    showing: false
  },
  salvo: null,
  token: null,
  rota: 'edicao',
  geral: {},
  overlay: false,
  dev: false
}